import { render } from "./Shipped.vue?vue&type=template&id=7ac133b8"
import script from "./Shipped.vue?vue&type=script&lang=js"
export * from "./Shipped.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/clients/client5/web28/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__